<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <!-- 产品服务头部模块 -->
            <div class="fw-hd">
                <div class="content_row">
                    <div class="fw-hd-left">
                        <h1>
                            对产品与服务的优化<br>我们一直在路上!
                        </h1>
                        <ul>
                            <li>专注更专注，完善更完善</li>
                        </ul>
                        <p>菜商云软件产品均为自主研发，稳定性好，延展性佳，可满足各类业态的不同需求。研发队伍服务意识强、经验丰富，具备高效、灵活的开发能力。</p>
                        <p>菜商云所用硬件设备均与行业优质供应商合作，保障性能与售后服务，让客户购后无忧。</p>
                        <p>菜商云运营服务均为专业自有团队负责，响应速度快。配合度高，与客户共同探索行业发展。</p>
                    </div>
                </div>
            </div>
            <!-- 产品介绍模块硬件模块 -->
            <div class="fw-bd">
                <div class="content_row">
                    <div class="fw-bd-box1">
                        <div class="title_content">
                            <div class="title">
                                <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                                <h1>数字农贸整体解决方案</h1>
                                <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                            </div>
                        </div>
                        <ul>
                            <li>
                                <img src="../assets/yj-pic.png" alt="">
                                <h3>数字农贸秤ADS-C款</h3>
                            </li>
                            <li>
                                <img src="../assets/yj-pic2.png" alt="">
                                <h3>数字农贸秤ADS-A款</h3>
                            </li>
                            <li>
                                <img src="../assets/yj-pic3.png" alt="">
                                <h3>红云2W智能称重收银机</h3>
                            </li>
                            <li>
                                <img src="../assets/yj-pic4.png" alt="">
                                <h3>红云MINI收银机</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 软件模块产品介绍 -->
            <div class="fw-bd-rj">
                <div class="content_row">
                    <div class="fw-bd-rj-box1">
                        <div class="title_content">
                            <div class="title">
                                <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                                <h1>数字农贸整体解决方案</h1>
                                <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                            </div>
                        </div>
                        <ul>
                            <li>
                                <img src="../assets/rj-1.png" alt="">
                                <h3>数字农贸管理平台</h3>
                            </li>
                            <li>
                                <img src="../assets/rj-3.png" alt="">
                                <h3>数字农贸商户小程序</h3>
                            </li>
                            <li>
                                <img src="../assets/rj-2.png" alt="">
                                <h3>数字农贸会员小程序</h3>
                            </li>
                            <li>
                                <img src="../assets/rj-4.png" alt="">
                                <h3>数字农贸管理小程序</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import BottomNav from '../components/BottomNav.vue'
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() { },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}


.fw-hd {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 5.2083rem;
    background: url(../assets/bj6.jpg) no-repeat center;
    background-size: 100% 5.2083rem;
    margin-top: .8333rem;
    z-index: -1;
}

.fw-hd .fw-hd-left {
    float: left;
    /* width: 6.0417rem; */
    /* height: 5rem; */
    margin-top: 0.1042rem;
}

.fw-hd .fw-hd-left h1 {
    width: 5.5rem;
    height: .7813rem;
    font-size: .4rem;
    letter-spacing: .0217rem;
    color: #fff;
    margin-top: 0.8rem;
    padding-bottom: .3rem;
    box-sizing: border-box;
}

.fw-hd .fw-hd-left ul {
    margin-top: .1729rem;
}

.fw-hd .fw-hd-left ul li {
    color: rgb(22, 210, 107);
    font-size: .25rem;
    font-weight: 700;
    margin-top: .4667rem;
    margin-bottom: .5208rem;
}

.fw-hd .fw-hd-left p {
    width: 80%;
    font-size: .2083rem;
    color: #fff;
    text-align: left;
    line-height: .3646rem;
    letter-spacing: .0208rem;
}

.fw-bd {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    height: 11rem;
    margin-top: .4167rem;
}

.fw-bd h1 {
    height: .5rem;
    font-size: .3958rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #232A24;
    line-height: .5rem;
}


.fw-bd .fw-bd-box1 ul {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding-bottom: .2083rem;
    border-bottom: 0.0313rem solid #ccc;
}

.fw-bd .fw-bd-box1 ul li {
    width: 48%;
    /* background-color: pink; */
    height: 4.25rem;
    margin-bottom: .2083rem;
    box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
}

.fw-bd .fw-bd-box1 ul li:nth-child(-n+2) {
    margin-top: 1rem;
}

.fw-bd .fw-bd-box1 ul li img {
    width: 65%;
    height: 3.525rem
}

.fw-bd .fw-bd-box1 ul li h3 {
    margin-top: .2083rem;
    color: #000;
}

.fw-bd-rj {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    /* background-color: pink; */
    text-align: center;
    box-sizing: border-box;
    height: 12.6042rem;
    margin-top: .4167rem;
}

.fw-bd-rj {
    position: relative;
}

.fw-bd-rj h1 {
    height: .5rem;
    font-size: .3958rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #232A24;
    line-height: .5rem;
}


.fw-bd-rj .fw-bd-rj-box1 ul {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding-bottom: .3125rem;
    border-bottom: 0.0313rem solid #ccc;
}

.fw-bd-rj .fw-bd-rj-box1 ul li {
    width: 48%;
    /* background-color: pink; */
    height: 4.75rem;
    margin-bottom: .2083rem;
    box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
}

.fw-bd-rj .fw-bd-rj-box1 ul li:nth-child(-n+2) {
    margin-top: 1rem;
}

.fw-bd-rj .fw-bd-rj-box1 ul li img {
    padding-top: .4167rem;
    padding-bottom: .4167rem;
    width: 85%;
    height: 4rem
}

.fw-bd-rj .fw-bd-rj-box1 ul li h3 {
    color: #000;
}
</style>